import { Col, Row } from 'antd';
import CollectionItem from "../collection/CollectionItem";
import { CollectionAssetModel } from 'src/models/CollectionModel';
import { useNavigate } from 'react-router';
import { RouteNames } from 'src/routes/routeName';
import EmptyBox from '../empty/EmptyBox';

interface TypeInterface {
  collections: CollectionAssetModel[];
}

export default function GalleryArtistCollection({ collections }: TypeInterface) {
  const navigate = useNavigate();

  const onClickItem = (collectionId: string) => {
    navigate(RouteNames.collection.replace(':id', collectionId));
  };

  return (
    collections.length === 0
      ?
      <EmptyBox />
      :
      <div className='collection'>
        <Row gutter={16}>
          <>
            {
              collections.map((collection, collectionIndex) => (
                <Col
                  className='mt-1'
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 12 }}
                  lg={{ span: 8 }}
                  xl={{ span: 6 }}
                >
                  <CollectionItem
                    collectionIndex={collectionIndex}
                    collectionId={collection.id}
                    collectionName={collection.name}
                    collectionItems={collection.collectionItems}
                    artistId={collection.userId}
                    nameColor='#fff'
                    onClickItem={(collectionId: string) => {
                      onClickItem(collectionId);
                    }}
                  />
                </Col>
              ))
            }
          </>
        </Row>
      </div>
  )
}